module.exports = __webpack_public_path__ + "img/tournaments.156506b2.svg";